import { useStatusStore } from './statusStore';
import { v4 as uuidv4 } from 'uuid';
import { BaseStatus } from './types';

export const addStatus = (status: Omit<BaseStatus, 'id' | 'timestamp'>) => {
  const store = useStatusStore.getState();
  const id = uuidv4();
  const timestamp = Date.now();
  store.addItem({ ...status, id, timestamp });
  if (status.autoDismiss) {
    setTimeout(() => store.deleteItem(id), status.timeout || 5000);
  }
  return id;
};

export const deleteStatus = (id: string) => {
  const store = useStatusStore.getState();
  store.deleteItem(id);
};

export const clearStatuses = () => {
  const store = useStatusStore.getState();
  store.setItems([]);
};
